import React from 'react';
import { DatePicker } from "./DatePicker-custom";
import moment from 'moment';
import styled from 'styled-components';
import { FormikErrors, FormikTouched, FieldProps } from 'formik';

type Props = {
    value?: Date;
    style?: any;
    placeHolder?: string;
    onChange?: any;
    error?: FormikErrors<Date> | undefined;
    touched?: FormikTouched<Date> | undefined;
    name: string;
    showTime?: boolean;
    field?: any;
    form?: any;
};

const CZDatePicker = (props: Props) => {
    // Check if it's used as a Formik Field component
    const isFormikField = props.field && props.form;
    
    const value = isFormikField ? props.field.value : props.value;
    const error = isFormikField ? props.form.errors[props.field.name] : props.error;
    const touched = isFormikField ? props.form.touched[props.field.name] : props.touched;
    
    const hasError = touched && error !== undefined;
    
    return (
        <Conatiner hasError={hasError}>
            <DatePicker
                field={props.field}
                form={props.form}
                name={props.name || props.field?.name}
                placeholder={props.placeHolder}
                style={{ ...props.style }}
                value={value ? moment(value) : undefined}
                showTime={props.showTime}
            />
            {hasError && <ErrorMessage>{error}</ErrorMessage>}
        </Conatiner>
    );
};

// Default props to avoid undefined errors
CZDatePicker.defaultProps = {
    style: {},
    placeHolder: 'Select date'
};

type ContainerProps = {
    hasError: boolean | undefined;
};

const ErrorMessage = styled.div`
    position: absolute;
    top: 27px;
    font-size: 11px;
    color: red;
`;

const Conatiner = styled.div<ContainerProps>`
    position: relative;
    & .ant-picker {
        border-radius: 70px !important;
        border-color: ${(props) => (props.hasError ? 'red' : props.theme.colors.primaryBlue)} !important;
    }
    
    /* Ensure DatePicker dropdown appears above modals */
    .ant-picker-dropdown {
        z-index: 1300 !important;
    }
`;

export default CZDatePicker;
